// Espelha PlatformCreditProduct#volume_unit_price: vale a maior faixa atingida pela quantidade.
export const volumeTiersFor = product =>
  [...(product?.volume_tiers || [])]
    .map(tier => ({
      minUnits: Number(tier.min_units),
      discount: Number(tier.discount_percentage),
    }))
    .filter(tier => tier.minUnits > 0 && tier.discount > 0)
    .sort((a, b) => a.minUnits - b.minUnits);

export const volumeDiscountFor = (product, units) =>
  volumeTiersFor(product)
    .filter(tier => Number(units) >= tier.minUnits)
    .reduce((best, tier) => Math.max(best, tier.discount), 0);

export const volumeUnitPrice = (product, units) => {
  const price = Number(product?.unit_price || 0);
  const discounted = (price * (100 - volumeDiscountFor(product, units))) / 100;
  return Math.round(discounted * 100) / 100;
};

export const volumeTotal = (product, units) =>
  Math.round(volumeUnitPrice(product, units) * Number(units || 0) * 100) / 100;
